<template>
    <div class="login-warpper">
        <div class="login-box">
            <img src="../assets/img/login-logo.png" alt="" class="login-logo">
            <div class="login-form">
                <h3><span></span>欢迎登录<span></span></h3>

                <div class="form-item">
                    <div class="form-icon">
                        <img src="../assets/img/account.png" alt="">
                    </div>
                    <input type="text" placeholder="请输入用户名" v-model="account">
                </div>
                <div class="form-item">
                    <div class="form-icon">
                        <img src="../assets/img/pass.png" alt="">
                    </div>
                    <input type="password" placeholder="请输入密码" v-model="pass">
                </div>
<!--                <div class="form-item">-->
<!--                    <drag-verify-->
<!--                        ref="dragVerify"-->
<!--                        :width="425"-->
<!--                        :height="48"-->
<!--                        :circle="false"-->
<!--                        :textSize="'14px'"-->
<!--                        completedBg="#f3b861"-->
<!--                        progressBarBg="#f3b861"-->

<!--                        :isPassing.sync="isPassing"-->
<!--                        text="请按住滑块拖动"-->
<!--                        successText="验证通过"-->
<!--                        handlerIcon="el-icon-d-arrow-right"-->
<!--                        successIcon="el-icon-circle-check"-->
<!--                        @passcallback="passcallback"-->
<!--                    >-->
<!--                    </drag-verify>-->
<!--                </div>-->
                <div class="login-btn" @click="loginSubmit">立即登录</div>

            </div>
        </div>
        <div style="position: fixed;left: 50%;bottom: 0;transform: translate(-50%,0)">
            <a style="color: #fff" href="https://beian.miit.gov.cn/" target="_blank">京ICP备15038897号-3</a>
            <a style="color: #fff;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214" target="_blank" class="margin-lr-xs"><img data-v-45865956="" src="http://www.beian.gov.cn/img/new/gongan.png" alt="">公安备案号：11010802038214</a>
        </div>
        <change-password-dialog :dialog="changePassword" :token="user.token" @cancelDialog="cancelDialog"></change-password-dialog>
    </div>
</template>

<script>
import {login} from '@/api/login'
// import dragVerify from 'vue-drag-verify2'
import ChangePasswordDialog from "@/components/ChangePasswordDialog";

export default {
    name: "login",
    data() {
        return {
            account: '',
            pass: '',
            isPassing: false,
            changePassword: false,
            user:''
        }
    },
    components: {
        ChangePasswordDialog,
        // dragVerify
    },
    created() {
        this.$store.state.token = ''
        this.$store.state.user = ''
        window.localStorage.clear()
    },
    methods: {
        passcallback() {
            this.isPassing = true
        },

        async loginSubmit() {
            if (!this.account) return this.$message.error('请输入用户名')
            if (!this.pass) return this.$message.error('请输入密码')
            // if (!this.isPassing) return this.$message.error('请滑动验证')
            const loading = this.$loading({
                lock: true,
                text: '登录中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _data = await login(this.account, this.pass)
            loading.close();
            if (_data.status === 200) {
                if (_data.data.easy_psd === 1) {
                    this.user = _data.data
                    this.changePassword = true
                } else {
                    this.setUser(_data.data)
                }

            } else {
                this.isPassing = false
                this.$refs.dragVerify.reset();
            }
        },
        setUser(data) {
            this.$store.state.token = data.token
            this.$store.state.user = data
            window.localStorage.setItem('token', JSON.stringify(data.token))
            window.localStorage.setItem('user', JSON.stringify(data))
            if (data.power === 6) {
                this.$router.replace('/home/server-tj')
            } else if (data.power === 7) {
                this.$router.replace('/home/month-finance')
            } else {
                this.$router.replace('/home/server-tj')
            }
        },
        cancelDialog(data) {
            if (data) this.$message.success('修改成功，请重新登录')
            this.changePassword = false
        }
    }
}
</script>

<style scoped lang="scss">
.login-warpper {
    display: block;
    width: 100%;
    min-height: 100vh;
    background: url(../assets/img/login-bg.jpg) no-repeat;
    background-size: 100% 100%;

    .login-box {
        display: block;
        width: 700px;
        margin: 0 auto;
        padding-top: 50px;

        .login-logo {
            display: block;
            height: 200px;
            margin: 0 auto 40px;
        }

        .login-form {
            width: 700px;
            padding: 30px;
            background: #fff;
            box-shadow: 0px 8px 18px 0px rgba(231, 231, 231, 0.32);
            border-radius: 8px;

            h3 {
                width: 400px;
                margin: 0 auto 20px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                text-align: center;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                height: 60px;
                color: #a6a6a6;

                span {
                    display: block;
                    width: 132px;
                    height: 2px;
                    background-color: #eeeeee;
                }
            }

            .form-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 425px;
                height: 50px;
                margin: 0 auto 20px;
                border-radius: 4px;
                border: solid 1px #e6e6e6;
                overflow: hidden;

                .form-icon {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    width: 46px;
                    height: 46px;
                }

                input {
                    flex: 1;
                    display: block;
                    font-size: 16px;
                    height: 46px;
                    background: transparent;
                }

                .form-btn {
                    padding: 0 10px;
                    color: #009688;
                }

                .form-yzm {
                    display: block;
                    width: 120px;
                    height: 46px;
                }
            }
        }

        .login-btn {
            display: block;
            width: 425px;
            height: 56px;
            margin: 0 auto;
            text-align: center;
            line-height: 54px;
            font-size: 18px;
            color: #fff;
            background-color: #f3b861;
            border-radius: 6px;
            border: solid 1px #eeeeee;
            cursor: pointer;
        }
    }
}
</style>
